/**
* Conditions Marquee JS
* -----------------------------------------------------------------------------
*
* All the JS for the Conditions Marquee component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
import Splide from '@splidejs/splide';
import {AutoScroll} from '@splidejs/splide-extension-auto-scroll';
( function( app ) {
  const COMPONENT = {

    className: 'conditions-marquee',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      if ( $( '.left-col__splide' ).length ) {
        $( '.left-col__splide' ).each( function( index, element ) {
          const slider = new Splide( $( element )[0], {
            type: 'loop',
            drag: false,
            direction: 'ttb',
            gap: '48px',
            arrows: false,
            pagination: false,
            autoHeight: true,
            height: $( '.conditions-marquee' ).height(),
            autoScroll: {
              speed: 0.5,
              pauseOnHover: false,
              pauseOnFocus: false,
            },
            breakpoints: {
              768: {
                direction: 'ltr',
                autoHeight: false,
                gap: '20px',
                fixedWidth: '205px',
                height: 'auto',
              },
            },
          } );
          slider.mount( {AutoScroll} );
        } );
      }
      if ( $( '.right-col__splide' ).length ) {
        $( '.right-col__splide' ).each( function( index, element ) {
          const slider = new Splide( $( element )[0], {
            type: 'loop',
            drag: false,
            direction: 'ttb',
            gap: '48px',
            arrows: false,
            pagination: false,
            autoHeight: true,
            height: $( '.conditions-marquee' ).height(),
            autoScroll: {
              speed: -0.5,
              pauseOnHover: false,
              pauseOnFocus: false,
            },
            breakpoints: {
              768: {
                direction: 'ltr',
                autoHeight: false,
                gap: '20px',
                fixedWidth: '205px',
                height: 'auto',
              },
            },
          } );
          slider.mount( {AutoScroll} );
        } );
      }
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'conditions-marquee', COMPONENT );
} )( app );
